// @ts-check
// ====== S2 partial: estrazione event-handlers To-do ======
// Listener bus dedicato. Logica CRUD/render resta in todos.js.

function wireTodosBusListeners() {
  // @ts-ignore — bus globale
  if (!globalThis.bus) return;
  // @ts-ignore
  globalThis.bus.on('todos:changed', () => {
    // @ts-ignore
    if (typeof renderTodos === 'function') renderTodos();
  });
}

document.addEventListener('DOMContentLoaded', wireTodosBusListeners);
wireTodosBusListeners();

export {};
